module.exports = __webpack_public_path__ + "img/new_about.ec0243f3.jpg";